import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DashboardComponent } from '../base-dashboard/dashboard.component';
import { LayoutService } from '../../../services/layout.service';
import { ChartsService } from '../../../services/charts.service';
import { SpinnerService } from '../../spinner/spinner.service';
import { ToastrService } from '../../../../../node_modules/ngx-toastr';
import { ExportService } from '../../../services/export.service';
import { BaseTile } from '../../tiles/dashboard-tiles/base-tile/base-tile';
import { SmallChartTileComponent } from '../../tiles/dashboard-tiles/small-chart-tile/small-chart-tile.component';
import { PeersService } from '../../../services/peers.service';
import { MyAccountService } from '../../../services/my-account.service';
import { JsReportService } from '../../../services/js-report.service';
import { DashboardId } from '../../../models/enum/dashboard-id';

@Component({
    selector: 'global-accounts-dashboard',
    templateUrl: './global-accounts-dashboard.component.html'
})
export class GlobalAccountsDashboardComponent extends DashboardComponent implements AfterViewInit {
    dashboardId = DashboardId.GlobalAccounts;
    dashboardHTMLId = 'global-accounts-dashboard-body';
    portraitExport = true;

    constructor(layoutService: LayoutService, chartsService: ChartsService, peersService: PeersService, jsReportService: JsReportService,
        spinnerService: SpinnerService, toastr: ToastrService, exportService: ExportService, myAccountService: MyAccountService) {
        super(layoutService, chartsService, peersService, jsReportService, spinnerService, toastr, exportService, myAccountService);
    }

    @ViewChild('GADashChart1') leftTile1!: SmallChartTileComponent;
    @ViewChild('GADashChart2') leftTile2!: SmallChartTileComponent;
    @ViewChild('GADashChart3') leftTile3!: SmallChartTileComponent;
    @ViewChild('GADashChart4') leftTile4!: SmallChartTileComponent;
    @ViewChild('GADashChart5') rightTile1!: SmallChartTileComponent;
    @ViewChild('GADashChart6') rightTile2!: SmallChartTileComponent;
    @ViewChild('GADashChart7') rightTile3!: SmallChartTileComponent;
    @ViewChild('GADashChart8') rightTile4!: SmallChartTileComponent;

    ngAfterViewInit() {
        this.componentMap = new Map<string, BaseTile>([
            ['GADashChart1', this.leftTile1],
            ['GADashChart2', this.leftTile2],
            ['GADashChart3', this.leftTile3],
            ['GADashChart4', this.leftTile4],
            ['GADashChart5', this.rightTile1],
            ['GADashChart6', this.rightTile2],
            ['GADashChart7', this.rightTile3],
            ['GADashChart8', this.rightTile4],
        ]);

        this.Init();
    }
}
